import { jsxs as e, jsx as l } from "react/jsx-runtime";
import i from "./Avatar.js";
import n from "./Icon.js";
const o = ({ avatar: s, children: a, name: t, title: r }) => /* @__PURE__ */ e("div", { className: "basis-0 bg-neutralWhite border border-neutralLightGrey flex flex-col flex-grow flex-shrink gap-6 items-center rounded-2xl p-5 shadow", children: [
  /* @__PURE__ */ e("p", { className: "tablet:text-lg desktop:my-auto", children: [
    '"',
    a,
    '"'
  ] }),
  /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-4 items-center justify-between w-full", children: [
    /* @__PURE__ */ e("div", { className: "flex gap-3 items-center", children: [
      /* @__PURE__ */ l(i, { image: s }),
      /* @__PURE__ */ e("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ l("span", { className: "font-bold text-blue-500", children: t }),
        /* @__PURE__ */ l("span", { className: "text-neutral-500 text-sm", children: r })
      ] })
    ] }),
    /* @__PURE__ */ l(
      n,
      {
        className: "text-indigo-100 text-[3.5rem]",
        name: "quote-right",
        style: "solid"
      }
    )
  ] })
] }), c = ({ className: s, children: a }) => /* @__PURE__ */ e("div", { className: s, children: [
  /* @__PURE__ */ l("h2", { className: "sr-only", children: "Testimonials" }),
  /* @__PURE__ */ l("div", { className: "container-sm flex flex-col gap-5 desktop:container-xl desktop:flex-row", children: a })
] });
c.Card = o;
export {
  c as default
};
